 export const requestedCategories = [
    {
        id:"other",
        name: "Other"
    },
    {
        id: "archiveDocumentRetrieval",
        name: "Archive Document Retrieval",
        firstMessage: 'To request documents that have been placed in remote storage status, please fill out the form below. Once submitted, an account representative will contact you. For inquiries regarding archive retrieval pricing, please contact Surgical Notes Account Management at acctmgrs@surgicalnotes.com or call 800-866-0656 (option 2).',
        secondMessage: `I hereby authorize and direct SN to retrieve the records I have requested. In consideration for SN's agreement to retrieve this information, I agree to be bound by these Terms and Conditions and to pay the amounts indicated on the web site. I understand and agree that SN will add the amounts referred to above to the next invoice delivered to me and that this amount is payable in accordance with the terms of the next invoice. I also understand and agree that SN intends to protect the privacy and provide for the security of PHI in its possession in compliance with the Health Insurance Portability and Accountability Act of 1996 ("HIPAA") and all regulations promulgated thereunder by the U.S. Department of Health and Human Services (the "HIPAA Regulations"), including without limitation its implementing privacy regulations at 45 C.F.R. Parts 160-164 ("HIPAA Privacy Rule"). I represent and warrant to SN that the information requested is the property of me or my employer and that this request for this information complies in all respects with the requirements of HIPAA, the HIPAA Regulations and the HIPAA Privacy Rule, and that the requested provision of the PHI does not and shall not violate HIPAA, the HIPAA Regulations, or the Privacy Rule. Protected Health Information has the meaning set forth in 45 Code of Federal Regulations Section 164.501, as amended from time to time. I and my employer hereby agree to indemnify, defend and hold SN harmless from and against any and all claims, demands, actions, suits, causes of action, costs, expenses, liabilities, obligations, judgments and settlement costs (including without limitation expenses of investigation, settlement, litigation, and attorneys' fees incurred in connection therewith), incurred by SN as a result of the delivery of the information as requested and directed by me. I and my employer shall pay all costs and expenses as incurred by SN. I further agree to accept the records in the condition in which they are delivered.`,
        additionalFields: [
            {
                name: "dateOfService",
                type: "date",
                required: true
            },
            {
                name: "patientId",
                type: "string",
                required: true
            },
            {
                name: "patientName",
                type: "string",
                required: true
            },
            {
                name: "jobId",
                type: "string",
                required: true
            }
        ],
        requiredCheckboxes: [
            {
                id:"agreeToTerms",
                title: 'Agree to Terms',
                checked: false
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/Pages/SupportRequestForm/requestCategories.js